export default function readyGuard(store) {
    return (to, from, next) => {
        if (!store.getters.authCheck || !store.getters.authUser.meta.gmh_ready) {
            next({ name: 'settings-profile-page' })
        } else {
            next()
        }
    }
}
